import { RESET_DASHBOARD_REQUESTED, RESET_DASHBOARD_COMPLETED } from './types';

const resetDashboardAction = () => (dispatch) => {
  dispatch({
    type: RESET_DASHBOARD_REQUESTED,
  });

  dispatch({
    type: RESET_DASHBOARD_COMPLETED,
  });
};

export default resetDashboardAction;
